var _defs, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.09 58.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .accent {\n        fill: #009245;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "accent",
    cx: 240.89,
    cy: 29.97,
    r: 28.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "accent",
    cx: 28.21,
    cy: 28.21,
    r: 28.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes3);
export default __webpack_public_path__ + "static/media/eyes3.557cce96.svg";
export { ForwardRef as ReactComponent };